export default "__VITE_ASSET__DbcoaMdy__"